import React, { useEffect, useState, useRef } from 'react';
import Papa from 'papaparse';
import { db } from '../firebase';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';

import { collection, getDocs, query, orderBy, updateDoc } from 'firebase/firestore';


const trades = [
  'Plumbing', 'Electrical', 'Landscaping', 'Painting', 'Carpentry', 'Roofing', 'Masonry', 'Other'
];
const parishes = [
  'Kingston', 'St. Andrew', 'St. Thomas', 'Portland', 'St. Mary', 'St. Ann',
  'Trelawny', 'St. James', 'Hanover', 'Westmoreland', 'St. Elizabeth',
  'Manchester', 'Clarendon', 'St. Catherine'
];

function Dashboard() {
  const [updatingStatusId, setUpdatingStatusId] = useState(null);
  const [maintenanceArchivingId, setMaintenanceArchivingId] = useState(null);
  const [maintenanceDeletingId, setMaintenanceDeletingId] = useState(null);
  const [contactArchivingId, setContactArchivingId] = useState(null);
  const [contactDeletingId, setContactDeletingId] = useState(null);
  // User management state
  const [users, setUsers] = useState([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteRole, setInviteRole] = useState('contractor');
  const [userLoading, setUserLoading] = useState(false);
  const [showUserMgmt, setShowUserMgmt] = useState(false);
  const [priceDraft, setPriceDraft] = useState({});
  const [updatingPriceId, setUpdatingPriceId] = useState(null);
  const [priceTypeDraft, setPriceTypeDraft] = useState({});

  const formatDraftCurrency = (input) => {
    const cleaned = String(input || '').replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    const whole = parts[0] || '';
    const decimals = parts[1] ? parts[1].slice(0, 2) : '';
    const joined = decimals ? `${whole}.${decimals}` : whole;
    return joined ? `$${joined}` : '';
  };
  // Update status handler
  const handleStatusChange = async (id, newStatus) => {
    setUpdatingStatusId(id);
    try {
      const reqRef = doc(db, 'maintenanceRequests', id);
      await updateDoc(reqRef, { status: newStatus });
      setMaintenanceRequests(prev => prev.map(r => r.id === id ? { ...r, status: newStatus } : r));
    } catch (error) {
      alert('Failed to update status.');
      console.error(error);
    }
    setUpdatingStatusId(null);
  };

  const handlePriceSave = async (id) => {
    const raw = priceDraft[id] ?? '';
    const numeric = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    if (Number.isNaN(numeric)) {
      alert('Enter a number for quote (JMD).');
      return;
    }
    const type = (priceTypeDraft[id] || '').trim() || 'quote';
    const formatted = new Intl.NumberFormat('en-JM', {
      style: 'currency',
      currency: 'JMD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numeric);
    setUpdatingPriceId(id);
    try {
      const reqRef = doc(db, 'maintenanceRequests', id);
      await updateDoc(reqRef, { price: formatted, priceType: type });
      setMaintenanceRequests(prev => prev.map(r => r.id === id ? { ...r, price: formatted, priceType: type } : r));
    } catch (error) {
      alert('Failed to update price.');
      console.error(error);
    }
    setUpdatingPriceId(null);
  };

  const archiveMaintenanceRequest = async (id) => {
    setMaintenanceArchivingId(id);
    try {
      const reqRef = doc(db, 'maintenanceRequests', id);
      await updateDoc(reqRef, { archived: true });
      setMaintenanceRequests(prev => prev.map(r => r.id === id ? { ...r, archived: true } : r));
    } catch (error) {
      alert('Failed to archive request.');
      console.error(error);
    }
    setMaintenanceArchivingId(null);
  };

  const deleteMaintenanceRequest = async (id) => {
    if (!window.confirm('Permanently delete this maintenance request?')) return;
    setMaintenanceDeletingId(id);
    try {
      await deleteDoc(doc(db, 'maintenanceRequests', id));
      setMaintenanceRequests(prev => prev.filter(r => r.id !== id));
    } catch (error) {
      alert('Failed to delete maintenance request.');
      console.error(error);
    }
    setMaintenanceDeletingId(null);
  };

  const archiveContactRequest = async (id) => {
    setContactArchivingId(id);
    try {
      const reqRef = doc(db, 'contactRequests', id);
      await updateDoc(reqRef, { archived: true });
      setContactRequests(prev => prev.map(r => r.id === id ? { ...r, archived: true } : r));
    } catch (error) {
      alert('Failed to archive contact request.');
      console.error(error);
    }
    setContactArchivingId(null);
  };

  const deleteContactRequest = async (id) => {
    if (!window.confirm('Permanently delete this contact request?')) return;
    setContactDeletingId(id);
    try {
      await deleteDoc(doc(db, 'contactRequests', id));
      setContactRequests(prev => prev.filter(r => r.id !== id));
    } catch (error) {
      alert('Failed to delete contact request.');
      console.error(error);
    }
    setContactDeletingId(null);
  };
  // contractor state not used in this admin view
  // const [contractor, setContractor] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  // editing state was unused - removed to satisfy linter
  const [maintenanceRequests, setMaintenanceRequests] = useState([]);
  const [filterParish, setFilterParish] = useState('');
  const [filterTrade, setFilterTrade] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [searchName, setSearchName] = useState('');
  const [showArchivedMaintenance, setShowArchivedMaintenance] = useState(false);
  const [contactRequests, setContactRequests] = useState([]);
  const [showArchivedContacts, setShowArchivedContacts] = useState(false);

  // Modal state
  const [modalRequest, setModalRequest] = useState(null);
  const [modalContact, setModalContact] = useState(null);
  const modalRef = useRef();

  const formatQuoteAcceptedAt = (value) => {
    if (!value) return '';
    try {
      if (typeof value.toDate === 'function') {
        return value.toDate().toLocaleString();
      }
      if (value.seconds) {
        return new Date(value.seconds * 1000).toLocaleString();
      }
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? '' : parsed.toLocaleString();
    } catch (err) {
      console.error('Failed to format quote acceptance timestamp', err);
      return '';
    }
  };
   
  // Close modal on outside click
  useEffect(() => {
    function handleClick(e) {
      if (modalRequest && modalRef.current && !modalRef.current.contains(e.target)) {
        setModalRequest(null);
      }
      if (modalContact && modalRef.current && !modalRef.current.contains(e.target)) {
        setModalContact(null);
      }
    }
    if (modalRequest || modalContact) {
      document.addEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [modalRequest, modalContact]);

  // CSV Export handler
  const exportToCSV = () => {
    // Apply all filters to maintenanceRequests
    const filtered = maintenanceRequests
      .filter(req => showArchivedMaintenance ? !!req.archived : !req.archived)
      .filter(req => !filterParish || req.parish === filterParish)
      .filter(req => !filterTrade || req.trade === filterTrade)
      .filter(req => !filterStatus || (req.status || 'open').toLowerCase() === filterStatus)
      .filter(req => {
        const name = (req.firstName + ' ' + req.lastName).toLowerCase();
        return !searchName || name.includes(searchName.toLowerCase());
      });
    if (filtered.length === 0) {
      alert('No requests to export.');
      return;
    }
    // Map to CSV fields
    const data = filtered.map(req => ({
      Name: req.firstName + ' ' + req.lastName,
      Trade: req.trade,
      Parish: req.parish,
      Address: req.address,
      Town: req.town,
      Phone: req.phone,
      Status: req.status || 'open',
      SubmittedAt: req.submittedAt && req.submittedAt.seconds ? new Date(req.submittedAt.seconds * 1000).toLocaleString() : '',
      OtherInfo: req.otherInfo || ''
    }));
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'maintenance_requests.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Check if user is admin (by email)
        if (user.email === 'islandlivingenterprises@gmail.com') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [auth]);

  // Fetch users for admin
  useEffect(() => {
    async function fetchUsers() {
      if (!isAdmin) return;
      setUserLoading(true);
      try {
        // Get all users from 'users' collection (admins + contractors)
        const userSnap = await getDocs(collection(db, 'users'));
        setUsers(userSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        setUsers([]);
      }
      setUserLoading(false);
    }
    fetchUsers();
  }, [isAdmin]);

  // Invite user handler
  const handleInviteUser = async (e) => {
    e.preventDefault();
    if (!inviteEmail) return alert('Enter an email.');
    setUserLoading(true);
    try {
      // Add user doc with role, email
      await setDoc(doc(db, 'users', inviteEmail), {
        email: inviteEmail,
        role: inviteRole,
        invitedAt: new Date().toISOString(),
      });
      setInviteEmail('');
      setInviteRole('contractor');
      // Refresh user list
      const userSnap = await getDocs(collection(db, 'users'));
      setUsers(userSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      alert('User invited!');
    } catch (err) {
      alert('Failed to invite user.');
    }
    setUserLoading(false);
  };

  // Remove user handler
  const handleRemoveUser = async (id) => {
    if (!window.confirm('Remove this user?')) return;
    setUserLoading(true);
    try {
      await setDoc(doc(db, 'users', id), {}, { merge: false }); // Overwrite with empty
      // Refresh user list
      const userSnap = await getDocs(collection(db, 'users'));
      setUsers(userSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      alert('User removed.');
    } catch (err) {
      alert('Failed to remove user.');
    }
    setUserLoading(false);
  };

  // Change user role handler
  const handleChangeUserRole = async (id, newRole) => {
    if (!window.confirm(`Change role for ${id} to ${newRole}?`)) return;
    setUserLoading(true);
    try {
      // Merge the new role into the user document
      await setDoc(doc(db, 'users', id), { role: newRole }, { merge: true });
      // Optimistically update UI
      setUsers(prev => prev.map(u => u.id === id ? { ...u, role: newRole } : u));
      alert('Role updated.');
    } catch (err) {
      console.error('Failed to change role', err);
      alert('Failed to change role. Check console for details.');
    }
    setUserLoading(false);
  };

  useEffect(() => {
    async function fetchRequests() {
      // Fetch maintenance requests
      const maintSnap = await getDocs(query(collection(db, 'maintenanceRequests'), orderBy('submittedAt', 'desc')));
      setMaintenanceRequests(maintSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      // Fetch contact requests
      const contactSnap = await getDocs(query(collection(db, 'contactRequests'), orderBy('submittedAt', 'desc')));
      setContactRequests(contactSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
    fetchRequests();
  }, []);

  if (loading) return <p>Loading dashboard...</p>;

  const filteredMaintenanceRequests = maintenanceRequests
    .filter(req => (showArchivedMaintenance ? !!req.archived : !req.archived))
    .filter(req => !filterParish || req.parish === filterParish)
    .filter(req => !filterTrade || req.trade === filterTrade)
    .filter(req => !filterStatus || (req.status || 'open').toLowerCase() === filterStatus)
    .filter(req => {
      const name = (req.firstName + ' ' + req.lastName).toLowerCase();
      return !searchName || name.includes(searchName.toLowerCase());
    });

  // handleUpdate removed (unused)
  return (
    <div className="dashboard">
      {/* Show simple greeting for admin, contractor card for others */}
      {isAdmin ? (
        <>
          <h2 style={{textAlign:'center',margin:'2rem 0 1.5rem 0',color:'#007b5e'}}>Welcome Admin</h2>
          <div style={{background:'#f3f8f6',borderRadius:'10px',padding:'1.5rem',marginBottom:'2rem',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:'1rem'}}>
              <h3 style={{marginBottom:'0',color:'#007b5e'}}>User Management</h3>
              <button
                onClick={()=>setShowUserMgmt(v=>!v)}
                style={{background:'#007b5e',color:'#fff',border:'none',borderRadius:'6px',padding:'0.45rem 0.9rem',fontWeight:'bold',cursor:'pointer'}}
              >
                {showUserMgmt ? 'Hide' : 'Show'}
              </button>
            </div>
            {showUserMgmt && (
              <>
                <form onSubmit={handleInviteUser} style={{display:'flex',gap:'1rem',margin:'1.2rem 0',alignItems:'center'}}>
                  <input type="email" value={inviteEmail} onChange={e=>setInviteEmail(e.target.value)} placeholder="User email" required style={{padding:'0.5rem',borderRadius:'5px',border:'1px solid #ccc',flex:'1 1 180px'}} />
                  <select value={inviteRole} onChange={e=>setInviteRole(e.target.value)} style={{padding:'0.5rem',borderRadius:'5px',border:'1px solid #ccc'}}>
                    <option value="admin">Admin</option>
                    <option value="contractor">Contractor</option>
                  </select>
                  <button type="submit" style={{background:'linear-gradient(90deg,#007b5e 60%,#00c6a7 100%)',color:'white',border:'none',borderRadius:'6px',padding:'0.6rem 1.2rem',fontWeight:'bold',fontSize:'1rem',cursor:'pointer'}}>Invite</button>
                </form>
                <div style={{overflowX:'auto'}}>
                  <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',borderRadius:'8px',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
                    <thead>
                      <tr style={{background:'#e7f6f2'}}>
                        <th style={{padding:'0.7rem',textAlign:'left'}}>Email</th>
                        <th style={{padding:'0.7rem',textAlign:'left'}}>Role</th>
                        <th style={{padding:'0.7rem',textAlign:'left'}}>Invited</th>
                        <th style={{padding:'0.7rem',textAlign:'left'}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userLoading ? (
                        <tr><td colSpan={4} style={{padding:'1rem',textAlign:'center'}}>Loading users...</td></tr>
                      ) : users.length === 0 ? (
                        <tr><td colSpan={4} style={{padding:'1rem',textAlign:'center'}}>No users found.</td></tr>
                      ) : (
                        users.map(u => (
                          <tr key={u.id}>
                            <td style={{padding:'0.7rem'}}>{u.email}</td>
                            <td style={{padding:'0.7rem'}}>
                              <select
                                value={u.role || ''}
                                onChange={e => handleChangeUserRole(u.id, e.target.value)}
                                style={{padding:'0.35rem',borderRadius:'5px',border:'1px solid #ccc'}}
                                disabled={userLoading}
                              >
                                <option value="">(none)</option>
                                <option value="admin">Admin</option>
                                <option value="contractor">Contractor</option>
                                <option value="client">Client</option>
                              </select>
                            </td>
                            <td style={{padding:'0.7rem'}}>{u.invitedAt ? new Date(u.invitedAt).toLocaleString() : ''}</td>
                            <td style={{padding:'0.7rem'}}>
                              <button onClick={()=>handleRemoveUser(u.id)} style={{background:'#fff',border:'1px solid #d9534f',color:'#d9534f',borderRadius:'5px',padding:'0.3rem 0.9rem',fontWeight:'bold',cursor:'pointer'}}>Remove</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </>
      ) : null}
      <hr style={{margin: '2rem 0'}} />
      <h3 style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:'1rem'}}>
        <span>Maintenance Requests</span>
        <button
          onClick={exportToCSV}
          style={{
            background: 'linear-gradient(90deg,#007b5e 60%,#00c6a7 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '0.6rem 1.2rem',
            fontWeight: 'bold',
            fontSize: '1rem',
            boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            cursor: 'pointer',
            transition: 'background 0.2s',
            marginLeft: 'auto'
          }}
        >
          ⬇️ Export to CSV
        </button>
      </h3>
      <div style={{margin:'1rem 0'}}>
        <label style={{fontWeight:'bold'}}>
          <input
            type="checkbox"
            checked={showArchivedMaintenance}
            onChange={e => setShowArchivedMaintenance(e.target.checked)}
            style={{marginRight:'0.5rem'}}
          />
          Show Archived Maintenance Requests
        </label>
      </div>
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center',
        marginBottom: '1.2rem', background: '#f9f9f9', padding: '1rem', borderRadius: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.06)'
      }}>
        <select value={filterParish} onChange={e => setFilterParish(e.target.value)} style={{ padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc' }}>
          <option value="">All Parishes</option>
          {parishes.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <select value={filterTrade} onChange={e => setFilterTrade(e.target.value)} style={{ padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc' }}>
          <option value="">All Trades</option>
          {trades.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={{ padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc' }}>
          <option value="">All Statuses</option>
          <option value="open">Open</option>
          <option value="in progress">In Progress</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
        <input
          type="text"
          placeholder="Search by name..."
          value={searchName}
          onChange={e => setSearchName(e.target.value)}
          style={{ padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc', flex: '1 1 180px' }}
        />
      </div>
      <ul className="dashboard-list">
        {filteredMaintenanceRequests.length === 0 && (
          <li>No {showArchivedMaintenance ? 'archived ' : ''}maintenance requests yet.</li>
        )}
        {filteredMaintenanceRequests.map(req => {
          const acceptedLabel = formatQuoteAcceptedAt(req.quoteAcceptedAt);
          return (
            <li key={req.id} className="dashboard-card">
              <strong>{req.trade}</strong> <br />
              {req.title} {req.firstName} {req.lastName}<br />
              <em>{req.address}, {req.town}, {req.parish}</em><br />
              <span>Phone: {req.phone}</span><br />
              {req.location && req.location.lat && req.location.lng && (
                <div style={{marginTop:'0.25rem'}}>
                  <span>Location: {req.location.lat.toFixed(5)}, {req.location.lng.toFixed(5)} </span>
                  <a
                    href={`https://www.google.com/maps?q=${req.location.lat},${req.location.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color:'#007b5e', fontWeight:'600'}}
                  >
                    View on map
                  </a>
                </div>
              )}
              {req.details && <span>Description: {req.details}</span>}<br />
              {req.otherInfo && <span>Other Info: {req.otherInfo}</span>}
              {req.quoteAccepted && (
                <div style={{marginTop:'0.55rem',background:'#e6f4ef',color:'#007b5e',borderRadius:'6px',padding:'0.35rem 0.6rem',fontWeight:'bold',display:'inline-flex',flexWrap:'wrap'}}>
                  Client accepted quote{acceptedLabel ? ` on ${acceptedLabel}` : ''}
                </div>
              )}
              <div style={{marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.7rem'}}>
                <span style={{fontWeight: 'bold', color: '#007b5e'}}>Status:</span>
                <select
                  value={req.status || 'open'}
                  onChange={e => handleStatusChange(req.id, e.target.value)}
                  style={{
                    padding: '0.4rem', borderRadius: '5px', border: '1px solid #ccc', fontWeight: 'bold', color: '#007b5e', minWidth: '120px', background: updatingStatusId === req.id ? '#e0f7ef' : 'white'
                  }}
                  disabled={updatingStatusId === req.id}
                >
                  <option value="open">Open</option>
                  <option value="in progress">In Progress</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
                {updatingStatusId === req.id && <span style={{color:'#007b5e', fontSize:'0.95rem'}}>Updating...</span>}
                <div style={{display:'flex',alignItems:'center',gap:'0.4rem',flexWrap:'wrap'}}>
                  <select
                    value={priceTypeDraft[req.id] ?? (req.priceType || 'quote')}
                    onChange={e => setPriceTypeDraft(prev => ({ ...prev, [req.id]: e.target.value }))}
                    style={{padding:'0.35rem',borderRadius:'5px',border:'1px solid #ccc'}}
                    aria-label="Quote type"
                  >
                    <option value="quote">Quote</option>
                    <option value="fixed price">Fixed price</option>
                  </select>
                  <input
                    type="text"
                    value={priceDraft[req.id] ?? (req.price ? `$${req.price.replace(/[^0-9.]/g,'')}` : '')}
                    onChange={e => setPriceDraft(prev => ({ ...prev, [req.id]: formatDraftCurrency(e.target.value) }))}
                    style={{padding:'0.35rem',borderRadius:'5px',border:'1px solid #ccc',width:'95px'}}
                    placeholder="$0.00"
                    aria-label="Quote amount"
                  />
                  <button
                    onClick={() => handlePriceSave(req.id)}
                    disabled={updatingPriceId === req.id}
                    style={{background:'#fff',border:'1px solid #007b5e',color:'#007b5e',borderRadius:'5px',padding:'0.35rem 0.8rem',fontWeight:'bold',cursor:'pointer'}}
                  >
                    {updatingPriceId === req.id ? 'Saving...' : 'Save'}
                  </button>
                </div>
                <button
                  style={{
                    marginLeft: 'auto',
                    background: '#fff',
                    border: '1px solid #007b5e',
                    color: '#007b5e',
                    borderRadius: '5px',
                    padding: '0.3rem 0.9rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    transition: 'background 0.2s',
                  }}
                  onClick={() => setModalRequest(req)}
                >
                  View Details
                </button>
                {!req.archived && (
                  <button
                    style={{
                      background: maintenanceArchivingId === req.id ? '#e0f7ef' : '#fff',
                      border: '1px solid #888',
                      color: '#888',
                      borderRadius: '5px',
                      padding: '0.3rem 0.9rem',
                      fontWeight: 'bold',
                      cursor: maintenanceArchivingId === req.id ? 'not-allowed' : 'pointer',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                      marginLeft: '0.5rem',
                    }}
                    onClick={() => archiveMaintenanceRequest(req.id)}
                    disabled={maintenanceArchivingId === req.id}
                    title="Archive this maintenance request"
                  >
                    {maintenanceArchivingId === req.id ? 'Archiving...' : 'Archive'}
                  </button>
                )}
                <button
                  style={{
                    background: maintenanceDeletingId === req.id ? '#fdecea' : '#fff',
                    border: '1px solid #d9534f',
                    color: '#d9534f',
                    borderRadius: '5px',
                    padding: '0.3rem 0.9rem',
                    fontWeight: 'bold',
                    cursor: maintenanceDeletingId === req.id ? 'not-allowed' : 'pointer',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    marginLeft: '0.5rem',
                  }}
                  onClick={() => deleteMaintenanceRequest(req.id)}
                  disabled={maintenanceDeletingId === req.id}
                  title="Delete this maintenance request"
                >
                  {maintenanceDeletingId === req.id ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </li>
          );
        })}
      </ul>

      {/* Request Detail Modal */}
      {modalRequest && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.25)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div ref={modalRef} style={{
            background: '#fff', borderRadius: '12px', boxShadow: '0 6px 32px rgba(0,0,0,0.18)',
            padding: '2.2rem 2.5rem', minWidth: '340px', maxWidth: '95vw', position: 'relative',
            fontSize: '1.08rem', width: '100%', maxHeight: '90vh', overflowY: 'auto'
          }}>
            <button
              onClick={() => setModalRequest(null)}
              style={{
                position: 'absolute', top: 18, right: 24, background: 'none', border: 'none', fontSize: '2.2rem', color: '#696767', cursor: 'pointer',
              }}
              aria-label="Close"
            >×</button>
            <h2 style={{color:'#007b5e',marginBottom:'1.2rem'}}>Request Details</h2>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0.7rem 1.5rem',marginBottom:'1.2rem'}}>
              <div><strong>Name:</strong> {modalRequest.title} {modalRequest.firstName} {modalRequest.lastName}</div>
              <div><strong>Trade:</strong> {modalRequest.trade}</div>
              <div><strong>Parish:</strong> {modalRequest.parish}</div>
              <div><strong>Town:</strong> {modalRequest.town}</div>
              <div><strong>Address:</strong> {modalRequest.address}</div>
              <div><strong>Phone:</strong> {modalRequest.phone}</div>
              {modalRequest.location && modalRequest.location.lat && modalRequest.location.lng && (
                <div style={{gridColumn:'1/3'}}>
                  <strong>Location:</strong> {modalRequest.location.lat.toFixed(5)}, {modalRequest.location.lng.toFixed(5)}{' '}
                  <a
                    href={`https://www.google.com/maps?q=${modalRequest.location.lat},${modalRequest.location.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color:'#007b5e', fontWeight:'600'}}
                  >
                    View on map
                  </a>
                </div>
              )}
              <div><strong>Status:</strong> {modalRequest.status || 'open'}</div>
              <div><strong>Submitted:</strong> {modalRequest.submittedAt && modalRequest.submittedAt.seconds ? new Date(modalRequest.submittedAt.seconds * 1000).toLocaleString() : ''}</div>
              {modalRequest.details && <div style={{gridColumn:'1/3'}}><strong>Description:</strong> {modalRequest.details}</div>}
              {modalRequest.otherInfo && <div style={{gridColumn:'1/3'}}><strong>Other Info:</strong> {modalRequest.otherInfo}</div>}
            </div>
            <div style={{textAlign:'right'}}>
              <button
                onClick={() => setModalRequest(null)}
                style={{
                  background: 'linear-gradient(90deg,#007b5e 60%,#00c6a7 100%)',
                  color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 1.2rem', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer',
                }}
              >Close</button>
            </div>
          </div>
        </div>
      )}
      <h3>Contact Requests</h3>
      <div style={{margin:'1rem 0'}}>
        <label style={{fontWeight:'bold'}}>
          <input
            type="checkbox"
            checked={showArchivedContacts}
            onChange={e => setShowArchivedContacts(e.target.checked)}
            style={{marginRight:'0.5rem'}}
          />
          Show Archived Contact Requests
        </label>
      </div>
      <ul className="dashboard-list">
        {(showArchivedContacts
            ? contactRequests.filter(req => req.archived)
            : contactRequests.filter(req => !req.archived))
          .length === 0 && (
            <li>
              No {showArchivedContacts ? 'archived ' : ''}contact requests yet.
            </li>
          )}
        {(showArchivedContacts
            ? contactRequests.filter(req => req.archived)
            : contactRequests.filter(req => !req.archived))
          .map(req => (
          <li key={req.id} className="dashboard-card">
            <strong>{req.name}</strong> ({req.email})<br />
            <em>{req.subject}</em><br />
            {req.message}
            <div style={{marginTop:'0.7rem',textAlign:'right'}}>
              <button
                style={{
                  background: '#fff',
                  border: '1px solid #007b5e',
                  color: '#007b5e',
                  borderRadius: '5px',
                  padding: '0.3rem 0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                  transition: 'background 0.2s',
                }}
                onClick={() => setModalContact(req)}
              >
                View Details
              </button>
              {!req.archived && (
                <button
                  style={{
                    background: contactArchivingId === req.id ? '#e0f7ef' : '#fff',
                    border: '1px solid #888',
                    color: '#888',
                    borderRadius: '5px',
                    padding: '0.3rem 0.9rem',
                    fontWeight: 'bold',
                    cursor: contactArchivingId === req.id ? 'not-allowed' : 'pointer',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    marginLeft: '0.5rem',
                  }}
                  onClick={() => archiveContactRequest(req.id)}
                  disabled={contactArchivingId === req.id}
                  title="Archive this contact request"
                >
                  {contactArchivingId === req.id ? 'Archiving...' : 'Archive'}
                </button>
              )}
              <button
                style={{
                  background: contactDeletingId === req.id ? '#fdecea' : '#fff',
                  border: '1px solid #d9534f',
                  color: '#d9534f',
                  borderRadius: '5px',
                  padding: '0.3rem 0.9rem',
                  fontWeight: 'bold',
                  cursor: contactDeletingId === req.id ? 'not-allowed' : 'pointer',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                  marginLeft: '0.5rem',
                }}
                onClick={() => deleteContactRequest(req.id)}
                disabled={contactDeletingId === req.id}
                title="Delete this contact request"
              >
                {contactDeletingId === req.id ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </li>
        ))}
      </ul>

      {/* Contact Request Detail Modal */}
      {modalContact && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.25)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div ref={modalRef} style={{
            background: '#fff', borderRadius: '12px', boxShadow: '0 6px 32px rgba(0,0,0,0.18)',
            padding: '2.2rem 2.5rem', minWidth: '340px', maxWidth: '95vw', position: 'relative',
            fontSize: '1.08rem', width: '100%', maxHeight: '90vh', overflowY: 'auto'
          }}>
            <button
              onClick={() => setModalContact(null)}
              style={{
                position: 'absolute', top: 18, right: 24, background: 'none', border: 'none', fontSize: '2.2rem', color: '#696767', cursor: 'pointer',
              }}
              aria-label="Close"
            >×</button>
            <h2 style={{color:'#007b5e',marginBottom:'1.2rem'}}>Contact Request Details</h2>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0.7rem 1.5rem',marginBottom:'1.2rem'}}>
              <div><strong>Name:</strong> {modalContact.name}</div>
              <div><strong>Email:</strong> {modalContact.email}</div>
              <div style={{gridColumn:'1/3'}}><strong>Subject:</strong> {modalContact.subject}</div>
              <div style={{gridColumn:'1/3'}}><strong>Message:</strong> {modalContact.message}</div>
              {modalContact.submittedAt && modalContact.submittedAt.seconds && (
                <div style={{gridColumn:'1/3'}}><strong>Submitted:</strong> {new Date(modalContact.submittedAt.seconds * 1000).toLocaleString()}</div>
              )}
            </div>
            <div style={{textAlign:'right'}}>
              <button
                onClick={() => setModalContact(null)}
                style={{
                  background: 'linear-gradient(90deg,#007b5e 60%,#00c6a7 100%)',
                  color: 'white', border: 'none', borderRadius: '6px', padding: '0.6rem 1.2rem', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer',
                }}
              >Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;